import Backdrop from "@material-ui/core/Backdrop"
import CircularProgress from "@material-ui/core/CircularProgress"
import { makeStyles } from "@material-ui/core/styles"

const useStyles = (initLoader) =>
  makeStyles((theme) => ({
    backdrop: {
      zIndex: 10000,
      color: "#fff",
      // Temp loader styles to differentiate the initializing loader vs backdrop loader
      ...(initLoader && {
        color: "black",
        backgroundColor: "white",
      }),
    },
  }))

const BackDropLoader = ({ open, initLoader = false }) => {
  const classes = useStyles(initLoader)()

  return (
    <Backdrop className={classes.backdrop} open={open}>
      <CircularProgress color="inherit" />
    </Backdrop>
  )
}

export default BackDropLoader
